// extracted by mini-css-extract-plugin
export default {"TermsAndConditions":"TermsAndConditions_TermsAndConditions__kmMs9"};